import { Card } from '../card'
import tw, { styled } from 'twin.macro'

export const SimpleCardRoot = styled(Card)`
  ${tw`py-8`}
`

export const SimpleCardTitle = styled.h3`
  ${tw`text-h3`}
`